import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, first, map, of, skipWhile, Subject, takeUntil } from 'rxjs';
import { LgvSnapshotHelper, LgvUserService, NotificationService } from '../../core/core.module';
import { PricingStatusName } from '../../core/enums/property.enum';
import { LgvClientService } from '../../core/services/lgv-client.service';
import { LgvCompanyService } from '../../core/services/lgv-company.service';
import { LgvPublicRecordModel } from '../../data-models/lgv-publicRecord.model';
import { LgvModel } from '../../data-models/longevity.model';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { EditLoanScenarioModalComponent } from '../edit-loan-scenario-modal/edit-loan-scenario-modal.component';
import { PublicRecordsModalComponent } from '../public-records-modal/public-records-modal.component';

@Component({
    selector: 'lus-property-detail-card',
    templateUrl: './property-detail-card.component.html',
    styleUrls: ['./property-detail-card.component.scss']
})
export class PropertyDetailCardComponent implements OnInit, OnDestroy, OnChanges {
    @Input() property: LgvModel.Property;
    @Input() showPublicRecordData: boolean;
    @Input() activeLoans: LgvModel.Loan[];
    @Input() inactiveLoans: LgvModel.Loan[];
    @Input() clientIdParam: string;
    @Output() openEditLoanDialog = new EventEmitter<any>();
    @Output() viewPublicRecord = new EventEmitter<any>();
    @Output() goToCreateLoan = new EventEmitter<any>();
    @Output() loadRefiOpportunities = new EventEmitter<any>();
    @Output() goToDashboard = new EventEmitter<any>();
    @Output() editLoanScenario = new EventEmitter<any>();
    onDestroy$ = new Subject();
    //prospectLoanOpportunities = [];

    get loanScenario(): LgvModel.LoanScenario { return !this.property || !this.property.loanScenarios || this.property.loanScenarios.length == 0 ? null : this.property.loanScenarios[0] }
    get isProspectProperty(): boolean { return this.property && this.property.associationType === 'Prospect' }

    _NoOppReasons: string[] = null;
    NoOppReasons$ = new BehaviorSubject(this._NoOppReasons);

    _opportunities: LgvModel.Opportunity[] = null;
    opportunities$ = new BehaviorSubject(this._opportunities);

    isLoadingOpportunities$ = this.lgvClientSvc.OpportunitiesState$.pipe(map((opp) => { return opp === 'Loading' }));

    constructor(public lgvClientSvc: LgvClientService,
        public lgvUserService: LgvUserService,
        private router: Router,
        public SSHlpr: LgvSnapshotHelper,
        public dialog: MatDialog,
        public lgvCompanySvc: LgvCompanyService,
        private matDialog: MatDialog,
        private notifService: NotificationService,
        private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(null);
        this.onDestroy$.complete();
    }

    removeClient() {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '250px',
            data: { Confirmation: `Are you sure you want to remove this property from your properties list?` }
        });

        dialogRef.afterClosed().pipe(takeUntil(this.onDestroy$)).subscribe((param) => {
            if (param.action) {
                this.lgvClientSvc.deleteProperty(this.lgvClientSvc.ClientID$.value, this.property.propertyInfo.id);
            }
        });
    }

    onOpenPublicRecords(prop: LgvModel.Property) {
        const dialogRef = this.matDialog.open(PublicRecordsModalComponent,
            {
                width: '750px',
                disableClose: true,
                data: {
                    property: prop,
                    clientId: this.lgvClientSvc.ClientID$.value
                }
            });

        dialogRef.afterClosed().pipe(takeUntil(this.onDestroy$)).subscribe(x => {
        });

    }

    onGoToCreateLoan(property: LgvModel.Property) {
        this.goToCreateLoan.emit(property);
    }

    onViewPublicRecord(pr) {
        this.viewPublicRecord.emit(pr);
    }

    OpenEditLoanDialog(loan) {
        this.openEditLoanDialog.emit(loan);
    }

    onPriceThisScenario(propertyId: string, scenarioId: string) {
        const url = `/#/admin/pricing-search/client/${this.lgvClientSvc.ClientID$.value}/property/${propertyId}/loanScenario/${scenarioId}`;
        this.router.navigate([url]);
    }

    onPriceThisLoan(loanId: string) {
        const url = `/#/admin/pricing-search/client/${this.lgvClientSvc.ClientID$.value}/property/${this.property.propertyInfo.id}/loan/${loanId}`;
        window.open(url, "_blank");
    }

    onEditThisScenario(propertyId: string, lScenario: LgvModel.LoanScenario) {
        this.editLoanScenario.emit({
            propertyId,
            lScenario
        });
    }

    // LoadOpportunitiesForLoan(Loan, true) {
    loadOwnedPropertyRefiOpportunities(loan) {
        this.loadRefiOpportunities.emit(loan?.loanInfo?.id)
    }

    loadProspectPropertyLoanOpportunities(loanScenarios) {
        const loanScenarioId = loanScenarios[0]?.id;
        //this.lgvClientSvc.LoadOpportunitiesForLoanOrLoanScenario(this.lgvClientSvc.ClientID$.value, null, loanScenarioId);

    }

    goToPropertyDashboard(propertyId) {
        const property = this.lgvClientSvc.SnapShot$.value?.properties.find(p => p.propertyInfo?.id === propertyId);
        if (this.property.associationType === 'Owned') {
            this.lgvClientSvc.SetSelectedClientPropertyAndLoan(property, this.activeLoans[0]);
        }
        else {
            this.lgvClientSvc.setSelectedClientPropertyAndLoanScenario(property, property?.loanScenarios[0]);
        }
        this.goToDashboard.emit();
    }

    loadOpportunities() {
        if (this.property.associationType === 'Owned') {
            this.lgvClientSvc.SetSelectedClientPropertyAndLoan(this.property, this.activeLoans[0]);
        }
        else {
            this.lgvClientSvc.setSelectedClientPropertyAndLoanScenario(this.property, this.property?.loanScenarios[0]);
        }
    }

    residenceName(type) {
        const suffix = type === 'Investment' ? ' Property' : ' Home'
        return type + suffix;
    }

    isNotSingleProperty() {
        return this.lgvClientSvc.SnapShot$.value?.properties?.length > 1;
    }

    removeLoan(loan) {
        this.lgvClientSvc.deleteClientLoan(this.lgvClientSvc.ClientID$.value, loan.loanInfo.id).pipe(
            takeUntil(this.onDestroy$),
            catchError(() => {
                this.notifService.error('There was an error removing your loan.');
                return of(null);
            })
        ).subscribe((x) => {
            if(x) {
                this.notifService.success('Loan successfully removed.');
            }
        })
    }
}
